import { repository } from 'dy-frontend-http-repository/lib/modules';
import { FileAttachmentResource } from 'dy-frontend-http-repository/lib/modules/UserNote/resources';
import { FileHashPreviewSize } from 'dy-frontend-shared/lib/data/valueObjects/FileHashPreview/enums';
import React, { HTMLAttributes } from 'react';

import FileTilePreview from '@app/components/FileTilePreview';
import Grid from '@app/components/Grid';
import DevText from '@app/components/Text';
import FileViewerModal, { FileViewerModalProps } from '@app/containers/modals/FileViewerModal';
import { openModal } from '@app/containers/modals/store/events';
import { fileHashPreview } from '@app/data/consts';
import { Button } from '@blueprintjs/core';

export interface ClientNoteFileAttachmentsProps {
    attachments: FileAttachmentResource[];
}

export type Props = HTMLAttributes<HTMLDivElement> & ClientNoteFileAttachmentsProps;

const ClientNoteFileAttachments: React.FC<Props> = ({ attachments, ...props }) => {
    if (attachments.length === 0) {
        return null;
    }

    const renderViewFile = (index: number) => {
        const handleViewFile = () => {
            openModal<FileViewerModalProps>({
                ModalComponent: FileViewerModal,
                data: {
                    files: attachments.map((f) => ({
                        name: f.file.original_name,
                        extension: f.file.extension,
                        size: f.file.size,
                        url: f.file.url,
                        downloadableUrl: repository.file().getDownloadableLink(f.file!.id),
                    })),
                    currentFileIndex: index,
                },
            });
        };

        return <Button minimal icon="eye-open" onClick={() => handleViewFile()} />;
    };

    const renderDownloadAssetButton = (url: string) => {
        return <Button minimal className="ml-small" icon="import" onClick={() => window.open(url)} />;
    };

    const renderFile = (attachment: FileAttachmentResource, index: number) => {
        let previewUrl: string | undefined;
        if (attachment.file.preview_path) {
            previewUrl = fileHashPreview.getPreviewUrl(attachment.file.preview_path, FileHashPreviewSize.SM);
        }

        return (
            <FileTilePreview
                useOnlySrcPresenceCheck
                fileName={attachment.file.original_name}
                fileSize={attachment.file.size}
                extension={attachment.file.extension}
                src={previewUrl}
                actions={
                    <>
                        {renderViewFile(index)}
                        {renderDownloadAssetButton(repository.file().getDownloadableLink(attachment.file.id))}
                    </>
                }
            />
        );
    };

    return (
        <div {...props}>
            <Grid container>
                {attachments.map((attachment, index) => (
                    <Grid className={index === 0 || index === 1 ? '' : 'mt-2'} key={attachment.file.id} lg={6} xs={12}>
                        {renderFile(attachment, index)}
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default ClientNoteFileAttachments;
